module.exports = __webpack_public_path__ + "img/bg_icon_01.69e9f5c5.svg";